import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MediaSection({
  button,
  color,
  'data-test-id': dataTestId,
  description,
  media,
  orientation,
  title
}) {
  const {
    textOrder,
    mediaTopPadding
  } = useResponsiveProps({
    textOrder: {
      sm: 0,
      // when going vertical for small screens, text part should always be first
      md: orientation === 'media-left' ? 1 : 0
    },
    mediaTopPadding: {
      xs: '800',
      sm: '800',
      md: undefined
    }
  });
  return /*#__PURE__*/_jsx(Flex, {
    backgroundColor: color,
    "data-test-id": dataTestId,
    justifyContent: "center",
    paddingBlock: "1400",
    paddingInline: "800",
    children: /*#__PURE__*/_jsxs(Grid, {
      maxInlineSize: "972px",
      children: [/*#__PURE__*/_jsxs(GridItem, {
        size: {
          sm: 12,
          md: 5
        },
        order: textOrder,
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          typography: "heading-600",
          marginBlockEnd: "400",
          children: title
        }), /*#__PURE__*/_jsx("p", {
          children: description
        }), button]
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          sm: 12,
          md: 7
        },
        paddingBlockStart: mediaTopPadding,
        children: media
      })]
    })
  });
}